import React from 'react';

export const ContextMenuSeparator = () => {
    return <div className="contextMenu--separator" />;
};